import React from 'react';
import NetlifyForm from 'react-netlify-form'
import Loader from './loader'

const applicationForm = () => {
    return (
        <div className="careers-wrapper">
            <div className="careers-form">
                <NetlifyForm name='application'>
                {({ loading, error, success }) => (
                    <div>
                    {loading &&
                        <div className="loader"> <Loader/></div>
                    }
                    {error &&
                        <div>Your information was not sent. Please try again later.</div>
                    }
                    {success &&
                        <div><h2>Thank you for your interest, your application has been submitted!</h2></div>
                    }
                    {!loading && !success &&
                        <div>

                <input 
                    className="input-style" 
                    type="text" 
                    name="Name" 
                    placeholder="Name*" 
                    required />
                <br/>
                <br/>
                <input 
                    className="input-style" 
                    type="email" 
                    name="Email" 
                    placeholder="Email*"  
                    required />
                <br/>
                <br/>
                <input 
                    className="input-style" 
                    type="number" 
                    name="PhoneNumber" 
                    placeholder="Phone Number*"  
                    required />
                <br/>
                <br/>
                <input 
                    className="input-style" 
                    type="text" 
                    name="PositionInterested" 
                    placeholder="Position Interested*"  
                    required />
                <br/>
                <br/>
                <input 
                    className="input-style" 
                    type="text" 
                    name="HowManyYearsOfExperience?" 
                    placeholder="How many years of experience (Position interested)?*"  
                    required/>
                <br/>
                <br/>
                <textarea 
                    type="text" 
                    className="input-style textarea-style" 
                    name="WhyDoYouWantToWorkHere?" 
                    placeholder="Why do you want to work for Silver State Pediatric?*" 
                    required>
                </textarea>
                <br/>
                <br/>
                <div className="upload">
                    <span>Resume Upload*:</span> 
                    <input 
                        className="file-style" 
                        type="file" 
                        name="Resume" />
                </div>
                <br/>
                <br/>
        
                <button type="submit">
                    <p className="submit">Submit</p>
                  </button>
                  </div>
                    }
                    </div>
                )}
                </NetlifyForm>
            </div>
            <style jsx>
            {
                `
                .loader {
                    text-align: center;
                    width: 100%;
                    margin: auto;
                }
                .careers-wrapper {
                    
                    background:linear-gradient(
                        to right, rgba(35,62,148, 0.9), rgba(58,157,175, 1)), url('https://images.unsplash.com/photo-1571210862729-78a52d3779a2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80') center center no-repeat;
                      background-size: cover;
                      
                    background-attachment: fixed;
                    padding-top: 4rem;
                    padding-bottom: 12rem;
                }
                .careers-form {
                    width: 50%;
                    padding: 40px 0 6rem;
                    margin: auto;
                    
                }
                button {
                    float: left !important;
                    width: 40%;
                    background: transparent;
                    border: 2px solid #fff;
                    outline: none;
                    color: #fff;
                    border-radius: 10px;
                 }
          
                .submit {
                     padding-right: 0 !important;
                     font-size: 16px !important;
                 }
                .input-style {
                    margin: 0 auto;
                    width: 100%;
                    height: 35px;
                    border-radius: 10px;
                    border: 2px solid #fff;
                    outline: none;
                    font-size: 15px;
                    padding: 0 0 0 10px;
                    background: transparent;
                    color: #fff !important;
                    // box-shadow: 0 20px 30px -14px rgba(0, 0, 0, 0.2);
                }
                h2 {
                    color: #fff;
                    font-size: 2rem;
                    text-align: center;
                    margin: 5rem 0 0;
                }
                ::placeholder { 
                    color: #fff;
                    opacity: 1;
                  }
                  
                  :-ms-input-placeholder {
                    color: #fff;
                  }
                  
                  ::-ms-input-placeholder {
                    color: #fff;
                  }

                .upload span {
                    font-weight: bold;
                    color: #fff;
                }
                .file-style {
                    color: #fff;                    
                    font-size: 16px;
                    display: flex;
                    
                }
                .textarea-style {
                    padding: 10px 0 0 5px !important;
                    height: 100px;
                    font-size: 15px;
                    letter-spacing: 0px;
                }
                .careers button {
                    float: left !important;
                    width: 40%;
                  
                 }
                 @media screen and (max-width: 760px) {
                    
                    .careers-form {
                      width: 80%;
                      padding-bottom: 0;
                    }

                    .input-style {
                      padding: 0px 4px;
                      margin: 0 auto;
                      
                    }

                    .careers button {
                      width: 100%;
                    }
                    button {
                        width: 100%;
                        
                     }
                  }
                `
            }
            </style>
        </div>
    );
};

export default applicationForm;